import Repository from "@shared/services/api/abstracts/Repository";
import { UserBasedTempFileSerializer } from "../types/temp-file-types";

export default class UserBasedTempFileRepository extends Repository<UserBasedTempFileSerializer> {
  public readonly repositoryName = "UserBasedTempFileRepository";

  public readonly endpoint = "/api/user/main/temp-files/";
}
